// extracted by mini-css-extract-plugin
module.exports = {"zoomer":"Zoomer_zoomer__YaZCz"};